module.exports = __webpack_public_path__ + "media/images/new_culture/bg-6-f419bd57e7c7b8708b5fd7ad12c21e69.jpeg";